import { AsyncState } from "widgets-for-react";

export const previousOrDefault = <A>(asyncState: AsyncState<A>, defaultValue: A) =>
  asyncState.kind == 'loaded' ? asyncState.value :
  asyncState.kind == 'loading' && asyncState.value != undefined ? asyncState.value :
  defaultValue
